var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('google-map',{attrs:{"sharer":_vm.sharer,"show-lengend":_vm.showLegend,"map-style":"elevation","show-sites":false,"legend":_vm.legend}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }